import { ArrowRight } from "lucide-react";
import { ctaContent } from "@/app/content/landingContent";

export function CtaSection() {
  return (
    <section
      id="cta"
      className="py-20 md:py-24 px-6 bg-[#004f4f]"
      aria-labelledby="cta-heading"
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2
          id="cta-heading"
          className="text-[clamp(1.875rem,4vw,3rem)] text-white mb-6 tracking-tight font-bold"
        >
          {ctaContent.heading}
        </h2>

        <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-white/90 leading-relaxed mb-12 max-w-prose mx-auto">
          {ctaContent.description}
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a
            href={ctaContent.primaryCta.href}
            className="inline-flex items-center gap-4 bg-white text-[#004f4f] px-8 py-4 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-[#004f4f] transition-colors font-bold text-base"
          >
            {ctaContent.primaryCta.label}
            <ArrowRight size={20} aria-hidden="true" />
          </a>

          <a
            href={ctaContent.secondaryCta.href}
            className="inline-flex items-center justify-center text-white font-semibold text-base underline decoration-2 underline-offset-4 hover:text-white/80 focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-[#004f4f] rounded-md px-4 py-4 transition-colors"
          >
            {ctaContent.secondaryCta.label}
          </a>
        </div>
      </div>
    </section>
  );
}
